import { createStyles, makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    success: {
      color: theme.palette.success.main
    },
    error: {
      color: theme.palette.error.main
    },
    avatar: {
      "& .MuiAvatar-root.MuiAvatar-circular": {
        height: "2.2rem",
        width: "2.2rem"
      }
    },
    text: {
      // fontWeight: 500,
      // // fontSize: "1.2rem", // Default font size
      // [theme.breakpoints.down("sm")]: {
      //   // Use Material-UI's breakpoint utility
      //   fontSize: "0.85rem" // Smaller font size for mobile
      // }
    }
  })
);
